<style lang="scss" scoped>
    .document-portfolio,
    .document-filter,
    .document-table {
        margin: 0 60px;
        padding: 0 15px;

        @media (max-width: 767px) {
            padding: 0 !important;
        }
    }

    .document-portfolio {
        margin-bottom: 25px;
    }

    .tab {
        display: inline-block;
        margin-bottom: 0;
        width: 20%;
    }

    .document-search {
        margin-right: 4px;
    }

    .document-public {
        @media (min-width: 768px) {
            margin: 0 0 25px 0;
            padding: 0;
        }
    }

    @media (min-width: 992px) {
        .results-wrapper {
            top: 25px !important;
        }
    }

    .first-group-buttons {
        @media (max-width: 767px) {
            margin: 0 0 5px 0 !important;
        }

        .document-search {
            @media (max-width: 767px) {
                width: calc(50% - 2px);
            }
        }

        .document-reset {
            @media (max-width: 767px) {
                width: calc(50% - 2px);
            }
        }
    }

    .form-group.second-group-buttons {
        margin-right: 0;

        .btn {
            @media (max-width: 767px) {
                width: 100%;
            }
        }
    }

    .document-query {
        border-color: #ddd;
        box-shadow: none;
        font-size: 14px;
        line-height: 20px;

        @media (max-width: 767px) {
            width: 100%;
        }

        &::-webkit-input-placeholder { /* Edge */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &::placeholder {
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }
    }

    .form-query__col {
        margin-bottom: 36px;

        .form-group__input {
            margin-right: 12px;

            @media (max-width: 767px) {
                width: 100%;
                margin-bottom: 5px;
            }
        }
    }

    .column-file-name {
        width: 40%;
    }

    .my-documents {
        .document-portfolio {
            ul {
                li:nth-child(6) {
                    a {
                        border-left: 0 !important;
                    }
                }

                li:nth-child(11) {
                    a {
                        border-left: 0 !important;
                    }
                }
            }
        }
    }
</style>

<template>
    <div class="my-documents">
        <top-bar v-if="!isPublic" active-item="documentation"/>

        <div class="document-portfolio" :class="{ 'document-public': isPublic }">
            <ul class="document-portfolio-category-tabs tabs nav nav-tabs" role="tablist">
                <li role="presentation" class="tab" v-for="(category, index) in categories"
                    :class="index === 0 ? 'active' : ''">
                    <a :href="category" :data="category" :aria-controls="category" role="tab" data-toggle="tab"
                       @click="setCategory(category)">
                        {{category === 'All' ? 'All Documents' : category}}
                    </a>
                </li>
            </ul>
        </div>

        <div class="document-filter" :class="{ 'document-public': isPublic }">
            <div class="form-query form-inline">
                <div class="row">
                    <div class="col-md-12 col-sm-12 form-query__col">
                        <div class="form-group form-group__input">
                            <input type="text" name="q" v-model="q" @keydown.enter="querySearch" class="document-query"
                                   placeholder="Filter...">
                        </div>
                        <div class="form-group first-group-buttons">
                            <input type="button" class="btn btn-primary document-search" value="Search"
                                   @click="querySearch">
                            <input type="button" class="btn btn-primary document-reset" value="Reset" @click="reset">
                        </div>
                    </div>
                </div>

                <div v-if="results">
                    <Paginator
                            :paginatorId="'MyDocuments'"
                            :results="results"
                            :page="page"
                            :paginate="setPage"
                            :pageSizes="pageSizes"
                            v-on:pageSizeChange="setPageSize"
                    />
                </div>
            </div>
        </div>

        <div class="document-table" :class="{ 'document-public': isPublic }">
            <div class="table-responsive filter-results">
                <table class="table table-striped tablesorter documents">
                    <thead>
                    <tr>
                        <th class="header" @click="sort('name')">File name</th>
                        <th class="header" @click="sort('title')">Title</th>
                        <th class="{sorter: false}"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="document in documents">
                        <td class="column-file-name">
                            <a class="icon" :href="document.link">
                                <span class="lnr icon lnr-file-empty" data-ext="pdf"></span>
                            </a>
                            <a :href="document.link"> {{document.name}}</a>
                        </td>
                        <td>{{document.title}}</td>
                        <td>
                            <a class="download" :href="document.link">
                                <span class="lnr lnr-download2"></span>
                            </a>
                        </td>
                    </tr>
                    <tr v-if="!results">
                        <td>No results found</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'
    import {FETCH_DOCUMENT_CATEGORIES, FETCH_DOCUMENTS, DOWNLOAD_DOCUMENTS} from "../store/actions.type";
    import {QUERY_CHANGED} from "../store/mutations.type";
    import Paginator from './Paginator';
    import TopBar from "./TopBar";
    import Utils from "../common/utils";

    export default {
        name: "MyDocuments",
        components: {
            Paginator,
            TopBar
        },
        props: {
            isPublic: {
                type: Boolean
            }
        },
        data() {
            return {
                q: "",
                sortBy: "",
                orderBy: ["asc", "desc", ""],
                pageSizes: [10, 25, 50, 100]
            };
        },
        computed: {
            ...mapGetters("myDocuments", ["documents", "categories", "results", "category", "page"]),
        },
        mounted() {
            this.commit(QUERY_CHANGED, {q: "", sort: "", order: "", page: 0, pageSize: this.pageSizes[0]});
            this.dispatch(FETCH_DOCUMENT_CATEGORIES).then(() => this.dispatch(FETCH_DOCUMENTS));
        },
        updated() {
            Utils.enableLinkTracking();
        },
        methods: {
            commit(mutation, payload) {
                return this.$store.commit('myDocuments/' + mutation, payload);
            },
            dispatch(action, payload) {
                return this.$store.dispatch('myDocuments/' + action, payload);
            },
            setCategory(category) {
                this.commit(QUERY_CHANGED, {category: category, page: 0});
                this.dispatch(FETCH_DOCUMENTS);
            },
            setPage(page) {
                this.commit(QUERY_CHANGED, {page: page - 1});
                this.dispatch(FETCH_DOCUMENTS);
            },
            setPageSize(pageSize) {
                this.commit(QUERY_CHANGED, {pageSize: parseInt(pageSize), page: 0});
                this.dispatch(FETCH_DOCUMENTS);
            },
            querySearch() {
                this.commit(QUERY_CHANGED, {q: this.q, page: 0});
                this.dispatch(FETCH_DOCUMENTS);
            },
            reset() {
                this.q = "";
                this.commit(QUERY_CHANGED, {q: "", sort: "", order: "", page: 0});
                this.dispatch(FETCH_DOCUMENTS);
            },
            sort(by) {
                if (by !== this.sortBy) {
                    this.sortBy = by;
                    this.orderBy = ["asc", "desc", ""];
                }
                let order = this.nextOrder();
                if (!order) {
                    this.sortBy = "";
                }
                this.commit(QUERY_CHANGED, {sort: this.sortBy, order: order});
                this.dispatch(FETCH_DOCUMENTS);
            },
            nextOrder() {
                let next = this.orderBy.shift();
                this.orderBy.push(next);
                return next;
            },
            downloadDocuments(queryParameters) {
                this.dispatch(DOWNLOAD_DOCUMENTS, queryParameters);
            }
        }
    };
</script>


